<template>
  <div class="search-block">
    <div class="search-input__wrap">
      <v-text-field
        class="search-input dark-input"
        prepend-icon="search"
        placeholder="Search"
        v-model="search"
        clearable
        autofocus
        clear-icon="cancel"
      />
    </div>

    <div class="list-field ml-0 mt-2">
      <div
        v-for="pattern in officePatternsFiltered"
        :key="pattern.pattern"
        :class="getItemClasses(pattern)"
        class="list-field__item"
        @click="selectPattern(pattern)"
      >
        <div>{{ pattern.label }}</div>
        <div class="pattern">{{ pattern.pattern }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'OfficePatternPicker',
  props: {
    value: {},
    patterns: {
      type: Array,
      default: () => [],
    },
    patternPrefix: String,
  },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    selectedOffice: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },

    officePatternsFiltered() {
      return this.officePatterns.filter((p) => {
        let pattern = p.pattern.toLowerCase();
        let label = p.label.toLowerCase();
        let filter = (this.search || '').trim().toLowerCase();
        return pattern.startsWith(filter) || label.startsWith(filter);
      });
    },

    officePatterns() {
      return this.prepareOfficePatterns();
    },
  },
  methods: {
    prepareOfficePatterns() {
      const patterns = cloneDeep(this.patterns.filter((p) => p.label));

      let formatted = [];

      let regions = patterns.filter((p) => {
        return p.pattern.length === 1;
      });

      let matching = (length, pattern) => {
        return (p) =>
          p.pattern.length === length && p.pattern.startsWith(pattern);
      };

      regions.forEach((region) => {
        formatted.push(region);
        let divisions = patterns.filter(matching(2, region.pattern));
        divisions.forEach((division) => {
          formatted.push(division);
          let offices = patterns.filter(matching(4, division.pattern));
          offices.forEach((o) => {
            formatted.push(o);
          });
        });
      });

      return formatted;
    },

    getItemClasses({ pattern, type }) {
      return [{ active: pattern == this.selectedOffice }, type];
    },

    selectPattern({ pattern }) {
      this.selectedOffice = pattern;
    },
  },
};
</script>

<style lang="less">
.search-block {
  padding: 12px;
  border-radius: @base-radius;
  overflow: hidden;
  background-color: #fff;
  box-shadow: @content-shadow;

  & > .v-btn.v-btn--text {
    width: 100%;
    padding: 0 14px !important;
    margin-left: 26px;

    .v-btn__content {
      justify-content: left;
      color: var(--v-primary-base);
    }
  }

  .v-text-field__details {
    display: block !important;
    min-height: 12px;

    .v-messages {
      min-height: 12px;
    }

    .v-messages__message {
      margin-top: 6px;
    }
  }

  div.search-input.v-input {
    .v-input__slot {
      padding: 4px 15px 4px 40px;
      box-shadow: none;
    }

    .v-input__prepend-outer {
      top: 5px;
      left: 8px;

      .v-icon {
        color: var(--v-appMain-base) !important;
      }
    }

    .v-input__append-inner {
      margin-top: 4px;
      margin-right: -5px;

      .v-icon {
        color: var(--v-appMain-base) !important;
      }
    }
  }

  .list-field {
    padding: 3px 0 0;
  }

  .list-field__item {
    font-size: @font-size-base;
    padding: 8px 15px;

    &.active {
      background: var(--v-appMain-base);
      div {
        color: var(--v-mainInvert-base) !important;
      }
    }
  }
}

.search-list {
  &__item {
    background-color: #fff;
  }
}

.search-input__wrap {
  display: flex;

  .v-btn {
    height: 40px !important;
    margin-left: 4px;
  }
}

.list-field__item {
  & > div {
    z-index: 1;
  }
  .pattern {
    margin-left: auto;
    opacity: 0.8;
    font-size: 12px;
  }

  &.region {
    font-size: 18px;
    font-weight: bold;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background: #eee;
      opacity: 0.48;
    }
  }

  &.division {
    font-size: 16px;
    font-weight: bold;
    padding-left: 30px;
  }

  &.office {
    padding-left: 48px;
  }
}
</style>

<style lang="less" src="@/assets/styles/basic/list-field.less"></style>
